import { defineComponent as n, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "f6c8a9cb-297d-4ec0-a73d-9cff46997a69" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#f6c8a9cb-297d-4ec0-a73d-9cff46997a69)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 345 256.7-25.5L512 345v167H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 167 255-23 257 23v178H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M0 0h512v167H0z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ n({
  __name: "de",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const t = a, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : f("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=de-69ed2d6f.js.map
